module.exports = __webpack_public_path__ + "azure-cloud-service.2147b9bdbb486657de6f844fe036ef23.hashedasset.svg";